import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_react_fc713198__ from "@tiptap/react";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_starter_kit_e62a8e0f__ from "@tiptap/starter-kit";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_extension_link_7142c077__ from "@tiptap/extension-link";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_extension_text_align_eb8fff2e__ from "@tiptap/extension-text-align";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_extension_text_style_94760d0d__ from "@tiptap/extension-text-style";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_extension_color_8085ada4__ from "@tiptap/extension-color";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_extension_underline_2dba25c6__ from "@tiptap/extension-underline";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_extension_strike_fb31fbc1__ from "@tiptap/extension-strike";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_extension_highlight_dc07b43d__ from "@tiptap/extension-highlight";
import * as __WEBPACK_EXTERNAL_MODULE__tiptap_extension_character_count_e92d3471__ from "@tiptap/extension-character-count";
import * as __WEBPACK_EXTERNAL_MODULE_dompurify__ from "dompurify";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__ from "./button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__ from "./popover.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__input_mjs_9e13df5e__ from "./input.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__label_mjs_b3d98bdc__ from "./label.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__ from "./select.mjs";
function RichTextEditor({ content = "", onChange, placeholder = "Start typing...", editable = true, className, height = "min-h-[150px]", width = "tw-w-full", characterLimit, enableStrikethrough = true, enableHighlight = true, enableDivider = true, enableTextColor = true, skipSanitization = false }) {
    const [linkUrl, setLinkUrl] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)("");
    const [characterCount, setCharacterCount] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(0);
    const sanitizedContent = skipSanitization ? content : __WEBPACK_EXTERNAL_MODULE_dompurify__["default"].sanitize(content);
    const editor = (0, __WEBPACK_EXTERNAL_MODULE__tiptap_react_fc713198__.useEditor)({
        extensions: [
            __WEBPACK_EXTERNAL_MODULE__tiptap_starter_kit_e62a8e0f__["default"],
            __WEBPACK_EXTERNAL_MODULE__tiptap_extension_link_7142c077__["default"].configure({
                openOnClick: false,
                HTMLAttributes: {
                    class: "tw-text-primary tw-underline"
                }
            }),
            __WEBPACK_EXTERNAL_MODULE__tiptap_extension_text_align_eb8fff2e__["default"].configure({
                types: [
                    "heading",
                    "paragraph"
                ],
                alignments: [
                    "left",
                    "center",
                    "right"
                ]
            }),
            __WEBPACK_EXTERNAL_MODULE__tiptap_extension_text_style_94760d0d__["default"],
            ...enableTextColor ? [
                __WEBPACK_EXTERNAL_MODULE__tiptap_extension_color_8085ada4__["default"]
            ] : [],
            __WEBPACK_EXTERNAL_MODULE__tiptap_extension_underline_2dba25c6__["default"],
            ...enableStrikethrough ? [
                __WEBPACK_EXTERNAL_MODULE__tiptap_extension_strike_fb31fbc1__["default"]
            ] : [],
            ...enableHighlight ? [
                __WEBPACK_EXTERNAL_MODULE__tiptap_extension_highlight_dc07b43d__["default"].configure({
                    HTMLAttributes: {
                        class: "tw-bg-yellow-200"
                    }
                })
            ] : [],
            __WEBPACK_EXTERNAL_MODULE__tiptap_extension_character_count_e92d3471__["default"].configure({
                limit: characterLimit
            })
        ],
        content: sanitizedContent,
        editable,
        editorProps: {
            attributes: {
                class: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-prose dark:tw-prose-invert tw-prose-sm sm:tw-prose-base lg:tw-prose-lg tw-max-w-none focus:tw-outline-neutral-300 tw-p-4 tw-overflow-y-auto", height, width, className)
            }
        },
        onUpdate: ({ editor })=>{
            const html = editor.getHTML();
            const sanitizedHtml = skipSanitization ? html : __WEBPACK_EXTERNAL_MODULE_dompurify__["default"].sanitize(html);
            null == onChange || onChange(sanitizedHtml);
            setCharacterCount(editor.storage.characterCount.characters());
        }
    });
    if (!editor) return null;
    const textStyles = [
        {
            name: "Paragraph",
            value: "paragraph"
        },
        {
            name: "Heading 1",
            value: "h1"
        },
        {
            name: "Heading 2",
            value: "h2"
        },
        {
            name: "Heading 3",
            value: "h3"
        }
    ];
    const colorOptions = [
        {
            label: "Default",
            value: "#000000"
        },
        {
            label: "White",
            value: "#ffffff"
        },
        {
            label: "Gray",
            value: "#6b7280"
        },
        {
            label: "Red",
            value: "#ef4444"
        },
        {
            label: "Orange",
            value: "#f97316"
        },
        {
            label: "Yellow",
            value: "#eab308"
        },
        {
            label: "Green",
            value: "#10b981"
        },
        {
            label: "Blue",
            value: "#3b82f6"
        },
        {
            label: "Purple",
            value: "#8b5cf6"
        },
        {
            label: "Pink",
            value: "#ec4899"
        }
    ];
    const getCurrentTextStyle = ()=>{
        if (editor.isActive("heading", {
            level: 1
        })) return "h1";
        if (editor.isActive("heading", {
            level: 2
        })) return "h2";
        if (editor.isActive("heading", {
            level: 3
        })) return "h3";
        return "paragraph";
    };
    const setTextStyle = (style)=>{
        if ("paragraph" === style) editor.chain().focus().setParagraph().run();
        else if ("h1" === style) editor.chain().focus().toggleHeading({
            level: 1
        }).run();
        else if ("h2" === style) editor.chain().focus().toggleHeading({
            level: 2
        }).run();
        else if ("h3" === style) editor.chain().focus().toggleHeading({
            level: 3
        }).run();
    };
    const setColor = (color)=>{
        if ("inherit" === color) editor.chain().focus().unsetColor().run();
        else editor.chain().focus().setColor(color).run();
    };
    const getCurrentColor = ()=>{
        const attributes = editor.getAttributes("textStyle");
        if (!attributes.color) return "#000000";
        return attributes.color;
    };
    const setLink = ()=>{
        if (linkUrl) {
            const url = linkUrl.trim();
            const urlWithProtocol = url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
            editor.chain().focus().extendMarkRange("link").setLink({
                href: urlWithProtocol
            }).run();
        } else editor.chain().focus().extendMarkRange("link").unsetLink().run();
    };
    const addHorizontalRule = ()=>{
        editor.chain().focus().setHorizontalRule().run();
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "tw-border tw-rounded-md tw-w-full",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "tw-flex tw-flex-wrap tw-p-1 tw-border-b tw-bg-muted/20",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: "tw-flex tw-items-center",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.Select, {
                            value: getCurrentTextStyle(),
                            onValueChange: setTextStyle,
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.SelectTrigger, {
                                    className: "tw-h-8",
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Type, {
                                            className: "tw-mr-2 tw-h-4 tw-w-4"
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.SelectValue, {
                                            placeholder: "Style"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.SelectContent, {
                                    children: textStyles.map((style)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.SelectItem, {
                                            value: style.value,
                                            children: style.name
                                        }, style.value))
                                })
                            ]
                        })
                    }),
                    enableTextColor && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                    variant: "ghost",
                                    size: "icon",
                                    className: "tw-h-8 tw-w-8",
                                    type: "button",
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                        className: "tw-relative tw-flex tw-items-center tw-justify-center",
                                        children: [
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Palette, {
                                                className: "tw-h-4 tw-w-4"
                                            }),
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                                className: "tw-absolute tw-bottom-0 tw-right-0 tw-h-2.5 tw-w-2.5 tw-rounded-sm tw-border tw-border-gray-300",
                                                style: {
                                                    backgroundColor: getCurrentColor()
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
                                className: "tw-p-2 tw-w-auto",
                                align: "start",
                                sideOffset: 5,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    className: "tw-grid tw-grid-cols-5 tw-gap-1",
                                    children: colorOptions.map((color)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                            variant: "ghost",
                                            size: "sm",
                                            type: "button",
                                            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-h-8 tw-w-8 tw-p-0 tw-rounded-sm tw-border tw-border-gray-200", getCurrentColor() === color.value && "tw-ring-2 tw-ring-primary tw-ring-offset-1"),
                                            title: color.label,
                                            onClick: ()=>setColor(color.value),
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                                className: "tw-h-6 tw-w-6 tw-rounded-sm tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-xs",
                                                style: {
                                                    backgroundColor: "inherit" !== color.value ? color.value : "transparent",
                                                    border: "inherit" === color.value ? "1px dashed currentColor" : "none",
                                                    color: [
                                                        "#ffffff",
                                                        "#eab308",
                                                        "#10b981",
                                                        "#3b82f6"
                                                    ].includes(color.value) ? "#000000" : "#ffffff"
                                                },
                                                children: "inherit" === color.value && "A"
                                            })
                                        }, color.value))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("bold") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleBold().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Bold, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("italic") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleItalic().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Italic, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("underline") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleUnderline().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Underline, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    enableStrikethrough && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("strike") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleStrike().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Strikethrough, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    enableHighlight && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("highlight") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleHighlight().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Highlighter, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("bulletList") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleBulletList().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.List, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("orderedList") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleOrderedList().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ListOrdered, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    enableDivider && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        onClick: addHorizontalRule,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.SeparatorHorizontal, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                    variant: "ghost",
                                    size: "icon",
                                    type: "button",
                                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive({
                                        textAlign: "center"
                                    }) || editor.isActive({
                                        textAlign: "right"
                                    }) ? "tw-bg-accent" : ""),
                                    children: [
                                        editor.isActive({
                                            textAlign: "center"
                                        }) && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.AlignCenter, {
                                            className: "tw-h-4 tw-w-4"
                                        }),
                                        editor.isActive({
                                            textAlign: "right"
                                        }) && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.AlignRight, {
                                            className: "tw-h-4 tw-w-4"
                                        }),
                                        !editor.isActive({
                                            textAlign: "center"
                                        }) && !editor.isActive({
                                            textAlign: "right"
                                        }) && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.AlignLeft, {
                                            className: "tw-h-4 tw-w-4"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
                                className: "tw-p-1 tw-w-auto",
                                align: "start",
                                sideOffset: 5,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                            variant: "ghost",
                                            size: "sm",
                                            type: "button",
                                            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-h-7 tw-px-2 tw-justify-start", editor.isActive({
                                                textAlign: "left"
                                            }) && "tw-bg-accent"),
                                            onClick: ()=>editor.chain().focus().setTextAlign("left").run(),
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                                className: "tw-flex tw-w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.AlignLeft, {
                                                        className: "tw-h-4 tw-w-4 tw-mr-2"
                                                    }),
                                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                                        children: "Left"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                            variant: "ghost",
                                            size: "sm",
                                            type: "button",
                                            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-h-7 tw-px-2 tw-justify-start", editor.isActive({
                                                textAlign: "center"
                                            }) && "tw-bg-accent"),
                                            onClick: ()=>editor.chain().focus().setTextAlign("center").run(),
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                                className: "tw-flex tw-w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.AlignCenter, {
                                                        className: "tw-h-4 tw-w-4 tw-mr-2"
                                                    }),
                                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                                        children: "Center"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                            variant: "ghost",
                                            size: "sm",
                                            type: "button",
                                            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-h-7 tw-px-2 tw-justify-start", editor.isActive({
                                                textAlign: "right"
                                            }) && "tw-bg-accent"),
                                            onClick: ()=>editor.chain().focus().setTextAlign("right").run(),
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                                className: "tw-flex tw-w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.AlignRight, {
                                                        className: "tw-h-4 tw-w-4 tw-mr-2"
                                                    }),
                                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                                        children: "Right"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                    variant: "ghost",
                                    size: "icon",
                                    type: "button",
                                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("link") && "tw-bg-accent"),
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.LinkIcon, {
                                        className: "tw-h-4 tw-w-4"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
                                className: "tw-w-80 tw-p-4",
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                    className: "tw-grid tw-gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                            className: "tw-grid tw-gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__label_mjs_b3d98bdc__.Label, {
                                                    htmlFor: "link",
                                                    children: "Link URL"
                                                }),
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__input_mjs_9e13df5e__.Input, {
                                                    id: "link",
                                                    placeholder: "https://example.com",
                                                    value: linkUrl,
                                                    onChange: (e)=>setLinkUrl(e.target.value),
                                                    onKeyDown: (e)=>{
                                                        if ("Enter" === e.key) {
                                                            e.preventDefault();
                                                            setLink();
                                                        }
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                            type: "button",
                                            onClick: setLink,
                                            children: editor.isActive("link") ? "Update Link" : "Add Link"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            editor && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__tiptap_react_fc713198__.BubbleMenu, {
                editor: editor,
                tippyOptions: {
                    duration: 100
                },
                className: "tw-bg-white tw-rounded-md tw-shadow-md tw-p-1 tw-flex tw-gap-1 tw-border",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("bold") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleBold().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Bold, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("italic") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleItalic().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Italic, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("underline") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleUnderline().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Underline, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    enableStrikethrough && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("strike") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleStrike().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Strikethrough, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    enableHighlight && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        variant: "ghost",
                        size: "icon",
                        type: "button",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("highlight") && "tw-bg-accent"),
                        onClick: ()=>editor.chain().focus().toggleHighlight().run(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Highlighter, {
                            className: "tw-h-4 tw-w-4"
                        })
                    }),
                    enableTextColor && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                    variant: "ghost",
                                    size: "icon",
                                    className: "tw-h-8 tw-w-8",
                                    type: "button",
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                        className: "tw-relative tw-flex tw-items-center tw-justify-center",
                                        children: [
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Palette, {
                                                className: "tw-h-4 tw-w-4"
                                            }),
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                                className: "tw-absolute tw-bottom-0 tw-right-0 tw-h-2.5 tw-w-2.5 tw-rounded-sm tw-border tw-border-gray-300",
                                                style: {
                                                    backgroundColor: getCurrentColor()
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
                                className: "tw-p-2 tw-w-auto",
                                align: "start",
                                sideOffset: 5,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    className: "tw-grid tw-grid-cols-5 tw-gap-1",
                                    children: colorOptions.map((color)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                            variant: "ghost",
                                            size: "sm",
                                            type: "button",
                                            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-h-8 tw-w-8 tw-p-0 tw-rounded-sm tw-border tw-border-gray-200", getCurrentColor() === color.value && "tw-ring-2 tw-ring-primary tw-ring-offset-1"),
                                            title: color.label,
                                            onClick: ()=>setColor(color.value),
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                                className: "tw-h-6 tw-w-6 tw-rounded-sm tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-xs",
                                                style: {
                                                    backgroundColor: "inherit" !== color.value ? color.value : "transparent",
                                                    border: "inherit" === color.value ? "1px dashed currentColor" : "none",
                                                    color: [
                                                        "#ffffff",
                                                        "#eab308",
                                                        "#10b981",
                                                        "#3b82f6"
                                                    ].includes(color.value) ? "#000000" : "#ffffff"
                                                },
                                                children: "inherit" === color.value && "A"
                                            })
                                        }, color.value))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                    variant: "ghost",
                                    size: "icon",
                                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(editor.isActive("link") && "tw-bg-accent"),
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.LinkIcon, {
                                        className: "tw-h-4 tw-w-4"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
                                className: "tw-w-80 tw-p-4",
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                    className: "tw-grid tw-gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                            className: "tw-grid tw-gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__label_mjs_b3d98bdc__.Label, {
                                                    htmlFor: "bubble-link",
                                                    children: "Link URL"
                                                }),
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__input_mjs_9e13df5e__.Input, {
                                                    id: "bubble-link",
                                                    placeholder: "https://example.com",
                                                    value: linkUrl,
                                                    onChange: (e)=>setLinkUrl(e.target.value),
                                                    onKeyDown: (e)=>{
                                                        if ("Enter" === e.key) {
                                                            e.preventDefault();
                                                            setLink();
                                                        }
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                            onClick: setLink,
                                            children: editor.isActive("link") ? "Update Link" : "Add Link"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__tiptap_react_fc713198__.EditorContent, {
                editor: editor,
                className: "tw-w-full [&_.is-editor-empty]:tw-before:content-[attr(data-placeholder)] [&_.is-editor-empty]:tw-before:text-muted-foreground [&_.is-editor-empty]:tw-before:float-left [&_.is-editor-empty]:tw-before:pointer-events-none [&_ul]:tw-list-disc [&_ul]:tw-pl-4 [&_ol]:tw-list-decimal [&_ol]:tw-pl-4 [&_mark]:tw-color-inherit"
            }),
            characterLimit && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "tw-p-2 tw-text-xs tw-text-muted-foreground tw-flex tw-justify-end tw-border-t",
                children: [
                    characterCount,
                    " / ",
                    characterLimit,
                    " characters"
                ]
            })
        ]
    });
}
export { RichTextEditor };

//# sourceMappingURL=rich-text-editor.mjs.map